// extracted by mini-css-extract-plugin
export default {"loader":"CustomRoute_loader__nsOlj"};